import { render, staticRenderFns } from "./UICheckBox.vue?vue&type=template&id=38da6cf5&scoped=true"
import script from "./UICheckBox.vue?vue&type=script&lang=js"
export * from "./UICheckBox.vue?vue&type=script&lang=js"
import style0 from "./UICheckBox.vue?vue&type=style&index=0&id=38da6cf5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38da6cf5",
  null
  
)

export default component.exports